<section *ngIf="articles().length > 0" class="hero-main-articles">
  <!-- Desktop Hero Background Images -->
  <div
    *ngFor="let article of articles(); let i = index; trackBy: trackByArticleId"
    class="hero-main-articles__background hero-main-articles__background--desktop"
    [class.hero-main-articles__background--active]="i === activeIndex()"
    [style.background-image]="'url(' + article?.image?.variants?.desktopHero?.url + ')'"
  ></div>

  <!-- Mobile Hero Background Images -->
  <div
    *ngFor="let article of articles(); let i = index; trackBy: trackByArticleId"
    class="hero-main-articles__background hero-main-articles__background--mobile"
    [class.hero-main-articles__background--active]="i === activeIndex()"
    [style.background-image]="'url(' + article?.image?.variants?.mobileHero?.url + ')'"
  ></div>

  <!-- Desktop Layout -->
  <div class="hero-main-articles__desktop">
    <div class="hero-main-articles__gradient"></div>

    <div class="hero-main-articles__content">
      <div class="hero-main-articles__featured">
        <a
          class="hero-main-articles__title"
          [routerLink]="['/', locale(), 'article', currentArticle().slug]"
        >
          {{ currentArticle().title }}
        </a>

        <!--TODO Like and Share Buttons -->
        <!--
        <div class="hero-main-articles__actions">
          <button class="hero-main-articles__like-button">
            <span class="hero-main-articles__like-icon"></span>
            <span class="hero-main-articles__like-count">2122</span>
          </button>
          <button class="hero-main-articles__share-button">
            <span class="hero-main-articles__share-icon"></span>
          </button>
        </div>
        -->
      </div>

      <nav class="hero-main-articles__slider" *ngIf="articles().length > 1">
        <ul class="hero-main-articles__slider-track">
          <li
            class="hero-main-articles__slider-item"
            *ngFor="let article of articles(); let i = index; trackBy: trackByArticleId"
            [class.hero-main-articles__slider-item--active]="i === activeIndex()"
          >
            <article
              class="hero-main-articles__slider-card"
              (click)="setActiveArticle(i)"
            >
              <div class="hero-main-articles__slider-content">
                <span
                  class="hero-main-articles__slider-category"
                  *ngIf="article.publication_category?.name"
                >
                  {{ article.publication_category.name }}
                </span>
                <h2 class="hero-main-articles__slider-title">
                  {{ article.title }}
                </h2>
              </div>

              <div
                class="hero-main-articles__slider-progress"
                [class.hero-main-articles__slider-progress--visible]="i === activeIndex()"
              >
                <div
                  class="hero-main-articles__slider-progress-bar"
                  [class.hero-main-articles__slider-progress-bar--animated]="
                    i === activeIndex()
                  "
                ></div>
              </div>
            </article>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- Mobile Layout -->
  <div class="hero-main-articles__mobile">
    <div class="hero-main-articles__mobile-content">
      <div class="hero-main-articles__mobile-text">
        <div class="hero-main-articles__mobile-info">
          <span
            class="hero-main-articles__mobile-category"
            *ngIf="currentArticle()?.publication_category?.name"
          >
            {{ currentArticle().publication_category.name }}
          </span>

          <a
            class="hero-main-articles__mobile-title"
            [routerLink]="['/', locale(), 'article', currentArticle().slug]"
          >
            {{ currentArticle().title }}
          </a>
        </div>
      </div>

      <nav class="hero-main-articles__mobile-nav" *ngIf="articles().length > 1">
        <div class="hero-main-articles__mobile-nav-track">
          <button
            class="hero-main-articles__mobile-nav-dot"
            [class.hero-main-articles__mobile-nav-dot--active]="i === activeIndex()"
            *ngFor="let article of articles(); let i = index; trackBy: trackByArticleId"
            (click)="setActiveArticle(i)"
          ></button>
        </div>
      </nav>
    </div>
  </div>
</section>
